/* Fransk katalog for locale-demo-reset-shortcut.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'demoReset.button': 'Réinitialiser la démo',
  'demoReset.title': 'Réinitialiser l\'entreprise de démonstration',
  'demoReset.message': 'Cette action supprime définitivement toutes les données comptables et d\'exploitation de cette entreprise de démonstration. Elle est irréversible.',
  'demoReset.preserved': 'Le profil de l\'entreprise, les membres, l\'abonnement et les connexions d\'intégration sont conservés.',
  'demoReset.phrase': 'CONFIRMER',
  'demoReset.typeLabel': 'Saisissez {phrase} pour activer la réinitialisation',
  'demoReset.typeHint': 'Vérifiez que la bonne entreprise de démonstration est sélectionnée avant de continuer.',
  'demoReset.confirm': 'Supprimer et réinitialiser la démo',
  'demoReset.complete': 'L\'entreprise de démonstration a été réinitialisée.',
  'demoReset.failed': 'Impossible de réinitialiser l\'entreprise de démonstration.',
  'demoReset.reason': 'L\'utilisateur a confirmé la réinitialisation rapide de l\'entreprise de démonstration en saisissant le mot de confirmation requis.',
  'demoReset.settingTitle': 'Afficher le raccourci de réinitialisation',
  'demoReset.settingHelp': 'Affiche « Réinitialiser la démo » au-dessus de SuperPlumma pour cette entreprise. Les autres entreprises du compte de démonstration sont configurées séparément.',
  'demoReset.settingEnabled': 'Le raccourci est activé pour cette entreprise de démonstration.',
  'demoReset.settingDisabled': 'Le raccourci est désactivé.',
});
